import { Flex, Spinner, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import React from 'react';
import { AccountResult } from './accountResult';
import { GameResult } from './gameResult';
import { ITransaction } from '../TransactionsList/transactionsList';
import { TransactionResult } from './transactionResult';
import { IGame } from '../../providers/Games/useGames';
import { IUser } from '../../providers/User/useUser';
import { Color } from 'src/theme/color';

export enum Type {
	USERS,
	GAMES,
	TRANSACTIONS,
}

const headerText: any = {
	[Type.USERS]: () => t('search.users').toString(),
	[Type.GAMES]: () => t('search.games').toString(),
	[Type.TRANSACTIONS]: () => t('search.transactions').toString(),
};

export const Results = ({
	type,
	data: { payload, isMore, isLoadingMore, getMore },
}: {
	type: Type;
	data: { payload: (IUser | IGame | ITransaction)[]; isMore: boolean; isLoadingMore: boolean; getMore: () => void };
}) => {
	const resultElement: any = {
		[Type.USERS]: (user: IUser) => (
			<AccountResult
				key={user.address}
				data={user}
			/>
		),
		[Type.GAMES]: (game: IGame, _: any) => (
			<GameResult
				key={`${game.address}${_}`}
				data={game}
			/>
		),
		[Type.TRANSACTIONS]: (transaction: ITransaction) => (
			<TransactionResult
				key={transaction.id}
				data={transaction}
			/>
		),
	};

	return payload.length ? (
		<Flex
			flexDirection="column"
			gridGap="24px"
			pb="32px"
			borderBottom="2px solid #393E4A"
			_last={{ pb: '0', borderBottom: 'none' }}
		>
			<Flex
				alignItems="flex-end"
				gridGap="12px"
			>
				<Text
					fontSize="16px"
					lineHeight="20px"
					fontWeight="700"
				>
					{headerText[type]()}
				</Text>
				<Flex
					padding="6px 12px"
					background="#3F4554"
					borderRadius="4px"
					fontSize="12px"
					lineHeight="15px"
					fontWeight="700"
				>
					{payload.length}
				</Flex>
			</Flex>
			{payload
				.slice(0)
				.reverse()
				.map((item, _) => resultElement[type](item, _))}
			{isMore ? (
				isLoadingMore ? (
					<Spinner
						w="14px"
						h="14px"
					/>
				) : (
					<Flex
						fontSize="14px"
						lineHeight="17px"
						cursor="pointer"
						onClick={getMore}
						gridGap="4px"
						pt="8px"
					>
						<Text color={Color.ACTION}>{t('search.moreResults').toString()}</Text>
						{/* <Text>+{payload.length - payload.length}</Text> */}
					</Flex>
				)
			) : (
				<></>
			)}
		</Flex>
	) : (
		<></>
	);
};
